import React, { useState, useEffect, useContext } from 'react';
import {
    Box, TablePagination, Paper, Table, TableBody, TableCell, TableContainer, TableHead,
    TableRow, Button, Chip, Collapse, IconButton, Typography, Dialog, DialogTitle, Alert,
    Autocomplete, DialogActions, DialogContent, Grid, Snackbar, TextField, ImageList,
    useMediaQuery, CircularProgress, ImageListItem, Stack, Avatar, ImageListItemBar, ListSubheader
} from '@mui/material';
import axios from 'axios';
import moment from 'moment';
import MainCard from 'components/MainCard';
import LinearProgress from '@mui/material/LinearProgress';
import Draggable from 'react-draggable';
import { MdRemove, MdAdd, MdSave, MdDeleteOutline, MdDialpad } from "react-icons/md";
import { n_format } from '../../n_format1';
import { LoadingButton } from '@mui/lab';
import { UpOutlined, DownOutlined, NodeExpandOutlined, RightOutlined } from '@ant-design/icons';
import { TreeView, TreeItem } from '@mui/x-tree-view';
import { SocketContext } from 'socket/SocketContext'

const levelColors = [
    "#FFD700", // Gold
    "#ADFF2F", // GreenYellow
    "#87CEEB", // SkyBlue
    "#FF69B4", // HotPink
    "#4CAF50", // Green
    "#2196F3", // Blue
    "#9C27B0", // Purple
    "#FF9800", // Orange
    "#00BCD4", // Cyan
    "#FFC107", // Amber
    "#E91E63", // Pink
    "#607D8B", // BlueGrey
];

const createTreeItems = (items = [], parentKey = '', level) => items.map((item) => {
    const key = `${parentKey}${parentKey ? '.' : ''}${item?.product_id}`;
    // console.log(key);
    return (
        <TreeItem key={key} nodeId={key}
            sx={{
                '& .MuiTreeItem-content': {
                    backgroundColor: levelColors[level % levelColors.length], // Assign color based on level
                    color: '#000', // Adjust text color if needed
                },
                '& .MuiTreeItem-root:before': {
                    backgroundColor: levelColors[(level + 1) % levelColors.length], // Assign color based on level
                },
            }}
            label={
                < Typography > {item?.name} {'==>'} {n_format(item?.qte_reserved, 2)} {item?.unit ?? ''}</Typography >
            }>
            {item?.product_composants_tree && item?.product_composants_tree.length > 0 && createTreeItems(item?.product_composants_tree, key, level + 1)}
        </TreeItem >
    );
});

function Row(props) {
    const { row, edit, set_dialog_item, set_dialog_edit_is_open, socket, print_bar_code } = props;
    const [checked, set_checked] = React.useState(false);
    const [open_subrow, set_open_subrow] = React.useState(false)
    const [open_subrow2, set_open_subrow2] = React.useState(false)
    const [edit_loading, set_edit_loading] = React.useState(false)

    // const print_bar_code = async (multi = false, data = null, all = false) => {
    //     console.log(data);
        
    //     let number = Number(1)

    //     if (all) number = data?.product1_qte
    //     else if (multi) number = Number(prompt("Combien de codes-barres voulez-vous ?"))

    //     if ((!isNaN(number) && number != 0 && multi) || !multi)
    //         try {
    //             // socket.trigger("CH1", "my-event", {
    //             //     message: "hello world"
    //             //   });
    //             socket.emit("print", {
    //                 device_id: JSON.parse(localStorage.getItem('company'))?.id,
    //                 value: {
    //                     code: data?.product1?.ref,
    //                     name: data?.product1?.name,
    //                     num: String(number)
    //                 }
    //             });
    //             // const res = axios.post(`${process.env.REACT_APP_API_URL}print`, {
    //             //     device_id: 1,
    //             //     code: dialog_item?.ref,
    //             //     name: dialog_item?.name,
    //             //     num: String(number)
    //             // });

    //             // const res = axios.post("https://192.168.1.204:443/print", {
    //             //     code: dialog_item?.ref,
    //             //     name: dialog_item?.name,
    //             //     num: String(number)
    //             // });
    //             // console.log(res.data); // ou afficher dans le UI
    //         } catch (err) {
    //             if (err.response) {
    //                 console.error("Erreur API :", err.response.data);
    //             } else {
    //                 console.error("Erreur réseau :", err.message);
    //             }
    //         }
    //     // else alert('Le nombre que vous avez saisi est incorrect!')
    // };

    useEffect(() => {
        new Promise((resolve, reject) => {
            setTimeout(() => {
                set_checked(!checked);
            }, 500);
        });
    }, [checked]);

    useEffect(() => {
        socket.on("poids", (data) => {
            set_dialog_item(o1 => {
                const details = Object.values(o1.operation_details ?? []);
                if (details.length === 0) return o1;

                // On modifie seulement le dernier élément
                const lastIndex = details.length - 1;
                const updatedDetails = details.map((p, i) =>
                    i === lastIndex
                        ? { ...p, product1_qte: parseFloat(data?.value?.poids ?? 0) }
                        : p
                );

                return { ...o1, operation_details: updatedDetails };
            });
        });
    }, [socket]);

    // useEffect(() => {
    //     socket.connect();
    //     console.log('socket connect');
    //     socket.onerror = (error) => {
    //         console.error('WebSocket error:', error);
    //     };
    //     // ✅ Listen for custom events
    //     socket.on("poids", (data) => {
    //         console.log("📩 New message:", data);
    //     });
    //     return () => {
    //         socket.disconnect();
    //         console.log('socket disconnect');
    //     };
    // }, []);

    useEffect(() => {
        if (!props?.edit_loading) set_edit_loading(false);
    }, [props?.edit_loading]);

    return (
        <React.Fragment>
            <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
                <TableCell>
                    <IconButton aria-label="expand row" size="small" onClick={() => set_open_subrow(!open_subrow)} >
                        {open_subrow ? <UpOutlined /> : <DownOutlined />}
                    </IconButton>
                </TableCell>
                {/* <TableCell>{row?.id}</TableCell> */}
                <TableCell sx={{ whiteSpace: 'nowrap' }}>{row?.ref}</TableCell>
                <TableCell>{row?.created_at && moment(row?.created_at)?.format('DD/MM HH:mm')}</TableCell>
                {/* <TableCell>{row?.company?.name}</TableCell> */}
                <TableCell>{row?.user?.name}</TableCell>
                {/* <TableCell>{row?.company1?.name}</TableCell> */}
                {/* <TableCell>{row?.user1?.name}</TableCell> */}
                {/* <TableCell sx={{ whiteSpace: 'nowrap' }}>{n_format(row?.price, 2, ' ', ',')} MAD</TableCell> */}
                <TableCell>
                    <Chip label={row?.status?.value} sx={{ color: row?.status?.color, bgcolor: row?.status?.bgcolor }} />
                </TableCell>
                <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
                    {edit_loading ?
                        <CircularProgress size={30} />
                        :
                        <>
                            {row?.status_key && row?.status_key == 10 && JSON.parse(localStorage.getItem('company'))?.id == row?.company1_id && (
                                <Button variant="outlined" color="success" onClick={() => { set_edit_loading(true), edit({ id: row?.id, status_key: 20 }) }}>
                                    Confirmer
                                </Button>
                            )}
                            {row?.status_key && row?.status_key == 300 && (
                                <Button variant="outlined" color="success" onClick={() => { set_edit_loading(true), edit({ id: row?.id, status_key: 310 }) }}>
                                    Confirmer
                                </Button>
                            )}
                            {row?.status_key && row?.status_key == 200 && JSON.parse(localStorage.getItem('company'))?.id == row?.company1_id && (
                                <Button variant="outlined" color="success" onClick={() => { set_edit_loading(true), edit({ id: row?.id, status_key: 210 }) }}>
                                    Confirmer
                                </Button>
                            )}
                            {row?.status_key && row?.status_key == 10 && (
                                <Button variant="outlined" color="warning" sx={{ ml: 1 }} onClick={() => { set_edit_loading(true), edit({ id: row?.id, status_key: 30 }) }}>
                                    Annuler
                                </Button>
                            )}
                            {/* {row?.status_key && row?.status_key == 10 && (
                                <Button variant="outlined" color="warning" sx={{ ml: 1 }} onClick={() => edit({ id: row?.id, status_key: 30 })}>
                                    Envoye Email
                                </Button>
                            )} */}
                            {row?.status_key && row?.status_key != 20 && row?.status_key != 30 && row?.status_key != 210 && row?.status_key != 310 && (
                                <Button variant="outlined" color="primary" sx={{ ml: 1 }}
                                    onClick={() => {
                                        set_dialog_edit_is_open(true);
                                        set_dialog_item(row);
                                    }}
                                >
                                    Edit
                                </Button>
                            )}
                            <Button variant="outlined" color="error" sx={{ ml: 1 }} onClick={() => props.delete1({ id: row?.id })}>
                                Supprimer
                            </Button>
                        </>
                    }
                </TableCell>
            </TableRow>
            <TableRow>
                <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                    <Collapse in={open_subrow} timeout="auto" unmountOnExit>
                        <Box sx={{ margin: 1 }}>
                            {/* <Typography variant="h6" gutterBottom component="div">
                            </Typography> */}
                            <Table size="small" aria-label="purchases">
                                <TableHead>
                                    <TableRow>
                                        {/* <TableCell>Produit Externe</TableCell> */}
                                        <TableCell>Produit</TableCell>
                                        {/* <TableCell>Prix Unitaire</TableCell> */}
                                        <TableCell>Qte</TableCell>
                                        {props.permissions?.includes('manufactures1.dialog1.fiche_technique') &&
                                            <TableCell sx={{ textAlign: 'center' }}>Arbre</TableCell>
                                        }
                                        {/* <TableCell>Prix HT</TableCell> */}
                                        {/* <TableCell>TVA (%)</TableCell> */}
                                        {/* <TableCell>Prix TTC</TableCell> */}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {row?.operation_details?.length > 0 && row?.operation_details.map((operation_detail, i) => (
                                        <TableRow key={i}>
                                            {/* <TableCell>{operation_detail?.product1?.name}</TableCell> */}
                                            <TableCell>{operation_detail?.product?.name}</TableCell>
                                            {/* <TableCell sx={{ whiteSpace: 'nowrap' }}>{n_format(operation_detail?.product1_price, 2, ' ', ',')} MAD</TableCell> */}
                                            <TableCell>{operation_detail?.product1_qte}</TableCell>
                                            {props.permissions?.includes('manufactures1.dialog1.fiche_technique') &&
                                                <TableCell>
                                                    <TreeView
                                                        defaultCollapseIcon={<NodeExpandOutlined />}
                                                        defaultExpandIcon={<RightOutlined />}
                                                        sx={{
                                                            '& .MuiTreeItem-root:before': {
                                                                content: '""',
                                                                position: 'absolute',
                                                                width: '5px',
                                                                top: 0,
                                                                bottom: 0,
                                                                left: 0,
                                                                backgroundColor: '#FFD700',
                                                            },
                                                            '& .MuiTreeItem-root': {
                                                                position: 'relative',
                                                                transition: 'all 0.3s ease-in-out',
                                                                '&:hover > .MuiTreeItem-content': {
                                                                    backgroundColor: '#e3f2fd',
                                                                    borderRadius: '4px',
                                                                },
                                                            },
                                                            '& .MuiTreeItem-content': {
                                                                // padding: '4px 12px',
                                                                margin: '4px 0',
                                                                borderRadius: '10px',
                                                                // color: '#455a64',
                                                                // transition: 'background-color 0.3s, box-shadow 0.3s',
                                                                // '&.Mui-focused': {
                                                                //     backgroundColor: '#e3f2fd',
                                                                //     boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                                                                // },
                                                                // '&:hover': {
                                                                //     backgroundColor: '#e1f5fe',
                                                                // },
                                                                // color: '#fff', // Adjust text color if needed
                                                            },
                                                            // '& .MuiTreeItem-label': {
                                                            //     fontWeight: 500,
                                                            //     fontSize: '1rem',
                                                            // },
                                                            // '& .MuiTreeItem-iconContainer': {
                                                            //     marginRight: '8px',
                                                            // },
                                                        }}
                                                        sx1={{
                                                            '& .MuiTreeItem-root:before': {
                                                                content: '""',
                                                                position: 'absolute',
                                                                width: '2px',
                                                                top: 0,
                                                                bottom: 0,
                                                                backgroundColor: '#ccc',
                                                            },
                                                            '& .MuiTreeItem-root': {
                                                                position: 'relative',
                                                            },
                                                            '& .MuiTreeItem-content': {
                                                            },
                                                        }}
                                                    // defaultCollapseIcon="▼"
                                                    // defaultExpandIcon="▶"
                                                    // multiSelect
                                                    >
                                                        {createTreeItems(operation_detail?.product_composants_tree, i, 0)}
                                                    </TreeView>
                                                    {/* <TreeView
                                                    aria-label="file system navigator"
                                                    // defaultCollapseIcon={<ExpandMoreIcon />}
                                                    // defaultExpandIcon={<ChevronRightIcon />}
                                                    defaultCollapseIcon="▼"
                                                    defaultExpandIcon="▶"
                                                    defaultExpanded={["1", "2", "5", "6", "8", "10"]} // Add all node IDs you want expanded
                                                    sx={{ height: 240, flexGrow: 1, maxWidth: 400, overflowY: 'auto' }}
                                                >
                                                    <TreeItem nodeId="1" label="Applications">
                                                        <TreeItem nodeId="2" label="Calendar" />
                                                    </TreeItem>
                                                    <TreeItem nodeId="5" label="Documents">
                                                        <TreeItem nodeId="10" label="OSS" />
                                                        <TreeItem nodeId="6" label="MUI">
                                                            <TreeItem nodeId="8" label="index.js" />
                                                        </TreeItem>
                                                    </TreeItem>
                                                </TreeView> */}
                                                </TableCell>
                                            }
                                            <TableCell>
                                                {row?.status_key == 210 &&
                                                    <Box sx={{ display: 'flex', gap: 3 }}>
                                                        <Button variant="outlined" color="primary" onClick={c => print_bar_code(false, operation_detail)}>
                                                            Print BarCode
                                                        </Button>
                                                        <Button variant="outlined" color="warning" onClick={c => print_bar_code(true, operation_detail)}>
                                                            Multi BarCode
                                                        </Button>
                                                        <Button variant="outlined" color="secondary" onClick={c => print_bar_code(true, operation_detail, true)}>
                                                            Imprimer
                                                        </Button>
                                                    </Box>
                                                }

                                            </TableCell>
                                            {/* <TableCell sx={{ whiteSpace: 'nowrap' }}>{n_format(operation_detail?.product1_price * operation_detail?.product1_qte, 2, ' ', ',')} MAD</TableCell> */}
                                            {/* <TableCell>{operation_detail?.product1_vta} %</TableCell> */}
                                            {/* <TableCell sx={{ whiteSpace: 'nowrap' }}>{n_format(operation_detail?.product1_price * operation_detail?.product1_qte * (1 + operation_detail?.product1_vta / 100), 2, ' ', ',')} MAD</TableCell> */}
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </Box>
                    </Collapse>
                    <Collapse in={open_subrow2} timeout="auto" unmountOnExit>
                        <Box sx={{ margin: 1 }}>
                            <Typography variant="h6" gutterBottom component="div">
                                History
                            </Typography>
                            <Table size="small" aria-label="purchases">
                                <TableHead>
                                    <TableRow>
                                        <TableCell />
                                        <TableCell>Num</TableCell>
                                        <TableCell>Temps</TableCell>
                                        <TableCell>Type</TableCell>
                                        <TableCell>Total</TableCell>
                                        <TableCell>Status</TableCell>
                                        <TableCell>Client</TableCell>
                                        <TableCell>Phone</TableCell>
                                        {/* <TableCell align="right">Actions</TableCell> */}
                                        {/* <TableCell /> */}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {row?.operation_details?.length > 0 && row?.operation_details.map((operation_details, i) => (
                                        <TableRow key={i}>
                                            <TableCell component="th" scope="row">
                                                {operation_details?.date}
                                            </TableCell>
                                            <TableCell>{operation_details?.customerId}</TableCell>
                                            <TableCell align="right">{operation_details?.amount}</TableCell>
                                            <TableCell align="right">
                                                {Math?.round(operation_details?.amount * row?.price * 100) / 100}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </React.Fragment>
    );
}

// function PaperComponent(props) {
//     return (
//         <Draggable handle="#dialog1-title" cancel={'[class*="MuiDialogContent-root"]'}>
//             <Paper {...props} />
//         </Draggable>
//     );
// }

const AppCRUD = () => {
    const [data, set_data] = useState([]);
    const [rows_count, set_rows_count] = useState(1);
    const [settings, set_settings] = useState({
        per_page: 5,
        page: 1,
        filters: [
            ["status_key", "in", [200, 210]]
        ]
    }); const [max_updated_at, set_max_updated_at] = useState(0);
    const [progress_num, set_progress_num] = useState(0);
    const [progress_seconde, set_progress_seconde] = useState(60 * 1);
    const [dialog_edit_is_open, set_dialog_edit_is_open] = useState(false);
    const [dialog_item, set_dialog_item] = useState({});
    const [companies, set_companies] = useState([]);
    const [products1, set_products1] = useState([]);
    const [products2, set_products2] = useState([]);
    const [products, set_products] = useState([]);
    const [snackbar, set_snackbar] = useState(false);
    const [operation_details, set_operation_details] = useState([]);
    const [edit_loading, set_edit_loading] = useState(false);
    const [payment_methods, set_payment_methods] = useState([{ payment_method: 'Règlement : Chèque ou espèces !!' }]);
    const [categoryOptions, setCategoryOptions] = useState([]);
    const [permissions, set_permissions] = useState([]);
    const [category, setCategory] = useState(null);
    const [dialog_edit_is_open1, set_dialog_edit_is_open1] = useState(false);
    const is_sm = useMediaQuery("(max-width:600px)");
    const socket = useContext(SocketContext);

    useEffect(() => {
        axios
            .post(`${process.env.REACT_APP_API_URL}permissions?route=datamanaging/manufactures1`)
            .then((res) => set_permissions(res?.data))
            .catch(() => console.log('error!'))
    }, [])

    useEffect(() => {
        fetchCategories()
        load_products1()
        const interval = setInterval(() => {
            set_progress_num((((moment().format('s') % progress_seconde) + 1) / progress_seconde) * 100);
            if (moment().format('s') % progress_seconde == 0) sync_data();
        }, 500);
        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        load_data()
        load_products()
        load_companies()
    }, []);

    useEffect(() => {
        load_data();
    }, [settings]);

    useEffect(() => {
        if (dialog_edit_is_open) {
            set_operation_details(dialog_item?.operation_details)
            load_products1()
            // setCategoryOptions([])
        }
    }, [dialog_edit_is_open]);

    useEffect(() => {
        if (Object.values(dialog_item.operation_details ?? []).filter(od => od?.product1_qte == 0).length > 0)
            set_dialog_item(o1 => ({
                ...o1,
                operation_details: Object.values(o1.operation_details ?? [])
                // operation_details: Object.values(o1.operation_details ?? []).filter(od => od?.product1_qte > 0)
            }))
    }, [dialog_item?.operation_details]);

    function calculateStartX(text, labelWidth = 590, fontWidth = 8.5) {
        const textWidth = text.length * fontWidth;
        const startX = Math.max(labelWidth - textWidth, 0);
        return startX;
    }

    const print_bar_code = async (multi = false, data = null, all = false) => {
        console.log(data);
        
        let number = Number(1)

        if (all) number = data?.product1_qte
        else if (multi) number = Number(prompt("Combien de codes-barres voulez-vous ?"))

        if ((!isNaN(number) && number != 0 && multi) || !multi)
            try {
                console.log(data);

                // socket.emit("print", {
                //     device_id: 110,
                //     value: {
                //         name: `^XA
                //                 ^CI28
                //                 ^CW1,E:TT0003M_.TTF

                //                 ^FO0,20^A0N,25,25^FB590,1,0,C^FDJAMBON NOISETTES^FS
                //                 ^FO200,40^A1N,20,20^FDجامبون نوازيت بقري^FS

                //                 ^FO30,70^A0N,22,22^FB590,2,5,L,0^FDviande de boeuf, sel de table, poivre blanc, ail en poudre, oignon en poudre, fécule de pomme de terre.^FS
                                
                //                 ^FO${calculateStartX("لحم بقر، ملح طعام، فلفل أبيض، ثوم بودرة، بصل بودرة، نشا البطاطس")},120
                //                 ^A1N,22,22
                //                 ^FD${"لحم بقر، ملح طعام، فلفل أبيض، ثوم بودرة، بصل بودرة، نشا البطاطس"}^FS

                //                 ^FO30,150^A0N,22,22^FDDate de production^FS
                //                 ^FO300,150^A0N,22,22^FD20/01/2026^FS
                //                 ^FO510,150^A1N,22,22^FDتاريخ الإنتاج^FS

                //                 ^FO30,170^A0N,22,22^FDDate d'expiration^FS
                //                 ^FO300,170^A0N,22,22^FD19/02/2026^FS
                //                 ^FO470,170^A1N,22,22^FDيستهلك إلى غاية^FS

                //                 ^FO30,190^A0N,22,22^FDPoids^FS
                //                 ^FO300,190^A0N,22,22^FD100 g^FS
                //                 ^FO552,190^A1N,22,22^FDالوزن^FS

                //                 ^FO30,210^A0N,22,22^FDN° de Lot^FS
                //                 ^FO300,210^A0N,22,22^FDJN1^FS
                //                 ^FO514,210^A1N,22,22^FDرقم الدفعة^FS

                //                 ^FO30,230^A0N,22,22^FDAgrément sanitaire^FS
                //                 ^FO300,230^A0N,22,22^FDPAV.5.4.26^FS
                //                 ^FO458,230^A1N,22,22^FDالترخيص الصحي^FS

                //                 ^FO30,250^A0N,22,22^FDA conserver^FS
                //                 ^FO300,250^A0N,22,22^FD3 °C^FS
                //                 ^FO425,250^A1N,22,22^FDيحفظ في درجة حرارة^FS

                //                 ^FO30,290^A0N,20,20^FDRue El Oqhouane, Magasin n°31, Hay Erraha, Casablanca, Maroc.^FS

                //                 ^FO100,310^A1N,20,20^FDزنقة الاقحوان محل تجاري رقم 31 حي الراحةالحي الحسني^FS

                //                 ^FO320,350^A0N,26,26^FDFabriqué par : RESO EAT^FS
                //                 ^FO340,370^A1N,26,26^FDصنع من طرف : ريزو إيت^FS

                //                 ^FO30,340
                //                 ^BY2
                //                 ^BCN,50,Y,N,N
                //                 ^FD123456789^FS

                //                 ^XZ`
                //     }
                // });
        
                socket.emit("print", {
                    device_id: JSON.parse(localStorage.getItem('company'))?.id,
                    value: {
                        name: `^XA
                                ^CI28
                                ^CW1,E:TT0003M_.TTF

                                ^FO0,20^A0N,25,25^FB590,1,0,C^FD${data?.product?.name}^FS
                                ^FO200,40^A1N,20,20^FD${data?.product?.name_ar}^FS

                                ^FO30,70^A0N,22,22^FB590,2,5,L,0^FD${data?.product?.designation}^FS
                                
                                ^FO${calculateStartX(data?.product?.designation_ar ?? "")},120
                                ^A1N,22,22
                                ^FD${data?.product?.designation_ar}^FS

                                ^FO30,150^A0N,22,22^FDDate de production^FS
                                ^FO300,150^A0N,22,22^FD${moment().format('DD/MM/YYYY')}^FS
                                ^FO510,150^A1N,22,22^FDتاريخ الإنتاج^FS

                                ^FO30,170^A0N,22,22^FDDate d'expiration^FS
                                ^FO300,170^A0N,22,22^FD${moment().add(data?.product?.max_jours_stock ?? 0, 'days').format('DD/MM/YYYY')}^FS
                                ^FO470,170^A1N,22,22^FDيستهلك إلى غاية^FS

                                ^FO30,190^A0N,22,22^FDPoids^FS
                                ^FO300,190^A0N,22,22^FD${data?.product1_qte} g^FS
                                ^FO552,190^A1N,22,22^FDالوزن^FS

                                ^FO30,210^A0N,22,22^FDN° de Lot^FS
                                ^FO300,210^A0N,22,22^FD${data?.product?.num_lot}^FS
                                ^FO514,210^A1N,22,22^FDرقم الدفعة^FS

                                ^FO30,230^A0N,22,22^FDAgrément sanitaire^FS
                                ^FO300,230^A0N,22,22^FDPAV.5.4.26^FS
                                ^FO458,230^A1N,22,22^FDالترخيص الصحي^FS

                                ^FO30,250^A0N,22,22^FDA conserver^FS
                                ^FO300,250^A0N,22,22^FD3 °C^FS
                                ^FO425,250^A1N,22,22^FDيحفظ في درجة حرارة^FS

                                ^FO30,290^A0N,20,20^FDRue El Oqhouane, Magasin n°31, Hay Erraha, Casablanca, Maroc.^FS

                                ^FO100,310^A1N,20,20^FDزنقة الاقحوان محل تجاري رقم 31 حي الراحةالحي الحسني^FS

                                ^FO320,350^A0N,26,26^FDFabriqué par : RESO EAT^FS
                                ^FO340,370^A1N,26,26^FDصنع من طرف : ريزو إيت^FS

                                ^FO30,340
                                ^BY2
                                ^BCN,50,Y,N,N
                                ^FD${data?.product?.ref}^FS

                            ^XZ`
                    }
                });


                // socket.trigger("CH1", "my-event", {
                //     message: "hello world"
                //   });
                // console.log({
                //     device_id: JSON.parse(localStorage.getItem('company'))?.id,
                //     value: {
                //         code: data?.product1?.ref,
                //         name: data?.product1_qte + 'g - ' + data?.product1?.name,
                //         num: String(number)
                //     }
                // });
                
                // socket.emit("print", {
                //     device_id: JSON.parse(localStorage.getItem('company'))?.id,
                //     value: {
                //         code: data?.product1?.ref,
                //         name: '[' + data?.product1_qte + 'g] ' + data?.product1?.name,
                //         num: String(number)
                //     }
                // });
                // const res = axios.post(`${process.env.REACT_APP_API_URL}print`, {
                //     device_id: 1,
                //     code: dialog_item?.ref,
                //     name: dialog_item?.name,
                //     num: String(number)
                // });

                // const res = axios.post("https://192.168.1.204:443/print", {
                //     code: dialog_item?.ref,
                //     name: dialog_item?.name,
                //     num: String(number)
                // });
                // console.log(res.data); // ou afficher dans le UI
            } catch (err) {
                if (err.response) {
                    console.error("Erreur API :", err.response.data);
                } else {
                    console.error("Erreur réseau :", err.message);
                }
            }
        // else alert('Le nombre que vous avez saisi est incorrect!')
    };

    const getRandomColor = (x) => {
        // const letters = '0123456789ABCDEF';
        const letters = 'FEDCBA9876543210';
        let color = '#';
        for (let i = 0; i < 6; i++) color += letters[(x * i + 4) % 16];
        return color;
    };

    const fetchCategories = async (dialog_item = null) => {
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}categories`, {
                per_page: 200,
                filters: [
                    ['products.type', 'in', ['PF']]
                ]
            });
            setCategoryOptions(response.data.data?.sort((a, b) => a.name.localeCompare(b.name)));
        } catch (error) {
            console.log('Error fetching categories:', error);
        }
    };

    const load_data = async () => {
        await axios
            .post(`${process.env.REACT_APP_API_URL}operations`, { ...settings, with: ['operation_details.product.product_composant_parents_type_pa'] })
            .then((res) => {
                try {
                    set_data(res?.data?.data);
                    set_rows_count(res?.data?.total);
                } catch (error) {
                    set_snackbar({ message: error?.message ?? 'Error ! Operation' });
                }
            })
            .catch((err) => set_snackbar({ message: 'Error ! Chargement de donnees' }));
    };

    const load_companies = async () => {
        await axios
            .post(`${process.env.REACT_APP_API_URL}companies`, { per_page: 200 })
            .then((res) => {
                set_companies(res?.data?.data);
            })
            .catch(() => console.log('error!'));
    };

    const load_products = async () => {
        set_products([]);
        await axios
            .post(`${process.env.REACT_APP_API_URL}products`, {
                per_page: 5000,
                filters: [
                    ['products.company_id', '=', JSON.parse(localStorage.getItem('company'))?.id],
                    ['type', 'in', ['SF', 'PF']]
                ]
            })
            .then((res) => {
                set_products(res?.data?.data);
            })
            .catch(() => console.log('error!'));
    };

    const load_products1 = async () => {
        set_products1([]);

        await axios
            .post(`${process.env.REACT_APP_API_URL}products`, {
                per_page: 5000,
                // filters: dialog_item
                filters: [
                    // ['category_id', dialog_item?.category_id],
                    ['type', 'in', ['PF']]
                ]
            })
            .then((res) => {
                set_products1(res?.data?.data);
            })
            .catch(() => console.log('error!'));
    };

    const load_products2 = async (di) => {
        set_products2([]);
        await axios
            .post(`${process.env.REACT_APP_API_URL}products`, {
                per_page: 200,
                // filters: di
                filters: {
                    // 'products.company_id': JSON.parse(localStorage.getItem('company'))?.id,
                    // 'category_id': di?.category_id
                    'id': di?.id
                },
                with: ["product_composant_parents_type_pa"]
            })
            .then((res) => {
                // console.log(di?.id);
                set_dialog_item(o1 => ({
                    ...o1,
                    operation_details: Object.values(o1.operation_details ?? []).map((p, pi) => p?.product1_id == di?.id ? { ...p, product_composant_parents_type_pa: Object.values(res?.data?.data?.[0]?.product_composant_parents_type_pa)?.filter(p => p?.parent_product_type_pa)?.map(p => p?.parent_product_type_pa) } : p)
                }))
                // console.log(Object.values(res?.data?.data?.[0]?.product_composant_parents_type_pa)?.filter(p => p?.parent_product_type_pa)?.map(p => p?.parent_product_type_pa));
                // console.log(Object.values(dialog_item.operation_details ?? []).map((p, pi) => p?.product1_id == di?.id ? { ...p, product_composant_parents: Object.values(res?.data?.data?.[0]?.product_composant_parents_type_pa)?.filter(p => p?.parent_product_type_pa)?.map(p => p?.parent_product_type_pa)} : p));

                // set_products2(Object.values(res?.data?.data?.[0]?.product_composant_parents_type_pa)?.filter(p => p?.parent_product_type_pa)?.map(p => p?.parent_product_type_pa));
            })
            .catch(() => console.log('error!'));
    };

    const sync_data = async () => {
        await axios
            .get(`${process.env.REACT_APP_API_URL}operations/max_updated_at`)
            .then((res) => {
                try {
                    if (res?.data != max_updated_at) load_data();
                    set_max_updated_at(res?.data);
                } catch (error) {
                    console.log(error);
                }
            })
            .catch(() => console.log('error!'));
    };

    // const edit1 = async (data = dialog_item) => {
    //     set_edit_loading(true)
    //     await axios
    //         .put(`${process.env.REACT_APP_API_URL}operations`, data)
    //         .then((res) => {
    //             try {
    //                 if (res?.data?.result) {
    //                     axios
    //                         .post(`${process.env.REACT_APP_API_URL}operations`, settings)
    //                         .then((res) => {
    //                             try {
    //                                 set_dialog_item(res?.data?.data.find(item => item.id === data?.id))
    //                             } catch (error) {
    //                                 set_snackbar({ message: error?.message ?? 'Error ! Operation' });
    //                             }
    //                         })
    //                         .catch((err) => set_snackbar({ message: 'Error ! Chargement de donnees' }));
    //                     set_snackbar({ message: 'Operation successfully updated!', type: 'success' });
    //                 } else set_snackbar({ message: res?.data?.message ?? 'Error ! Edit Operation' });
    //             } catch (error) {
    //                 set_snackbar({ message: error?.message });
    //                 // console.log('error : ' + 'operations' + '!');
    //             }
    //         })
    //         .catch((e) => set_snackbar({ message: e?.message }));
    //     set_edit_loading(false)
    // };

    const edit = async (data = dialog_item) => {
        set_edit_loading(true)
        await axios
            .put(`${process.env.REACT_APP_API_URL}operations`, data)
            .then((res) => {
                try {
                    if (res?.data?.result) {
                        load_data();
                        // set_dialog_edit_is_open(false);
                        // set_dialog_edit_is_open1(false);

                        // console.log(dialog_item?.operation_details?.[0]?.product1_qte);
                        
                        print_bar_code(false, Object.values(dialog_item?.operation_details ?? [])[0])
                        // set_dialog_item(o1 => ({
                        //     ...o1,
                        //     operation_details: Object.values(o1.operation_details ?? []).map((p, pi) =>
                        //         pi === 0
                        //             ? { ...p, product1_qte: 0 }
                        //             : p
                        //     )
                        // }));

                        set_dialog_item(o1 => {
                            const details = Object.values(o1.operation_details ?? []);
                            if (details.length === 0) return o1;

                            // On modifie seulement le dernier élément
                            const lastIndex = details.length - 1;
                            const updatedDetails = details.map((p, i) =>
                                i === lastIndex
                                    ? { ...p, product1_qte: parseFloat(0) }
                                    : p
                            );

                            return { ...o1, operation_details: updatedDetails };
                        });

                        set_snackbar({ message: 'Operation successfully updated!', type: 'success' });
                    } else set_snackbar({ message: res?.data?.message ?? 'Error ! Edit Operation' });
                } catch (error) {
                    set_snackbar({ message: error?.message });
                    // console.log('error : ' + 'operations' + '!');
                }
            })
            .catch((e) => set_snackbar({ message: e?.message }));
        set_edit_loading(false)
    };

    const delete1 = async (data) => {
        const confirmed = window.confirm('Are you sure you want to delete this element?');
        if (!confirmed) {
            return; // If the user cancels the confirmation, exit the function
        }

        await axios
            .delete(`${process.env.REACT_APP_API_URL}operations`, { data: data })
            .then((res) => {
                try {
                    if (res?.data?.result) {
                        load_data();
                        set_snackbar({ message: 'Operation successfully deleted!', type: 'success' });
                    } else set_snackbar({ message: res?.data?.message ?? 'Error ! Delete Operation' });
                } catch (error) {
                }
            })
    };

    const MainCardButtonAdd = (
        <Box>
            <Button
                sx={{ mx: 1 }}
                type="submit"
                variant="contained"
                color="primary"
                onClick={() => { setCategory(null), set_dialog_item({ company1_id: JSON.parse(localStorage.getItem('company'))?.id, status_key: 210, operation_details: [{ product1_qte: '', dialpad: true }] }), set_dialog_edit_is_open1(true) }}
            >
                Préparer
            </Button>
        </Box>
    );

    return (
        <MainCard title="Fabrications" secondary={MainCardButtonAdd}>
            <Snackbar
                open={snackbar ? true : false}
                autoHideDuration={snackbar?.hide_duration ?? 3000}
                onClose={() => { set_snackbar(false); }}
            >
                <Alert
                    onClose={() => { set_snackbar(false); }}
                    severity={snackbar?.type ?? 'error'} // success error warning info
                    sx={{ width: '100%' }}
                >
                    {snackbar?.message}
                </Alert>
            </Snackbar>

            <LinearProgress variant="determinate" value={progress_num} sx={{ mb: 2 }} />

            <Box>
                <TablePagination
                    rowsPerPageOptions={[5, 10, 15, 25, 50]}
                    component="div"
                    labelRowsPerPage="Ligne/Page"
                    count={rows_count}
                    rowsPerPage={settings?.per_page}
                    page={settings?.page - 1}
                    onPageChange={(event, newPage) => set_settings({ ...settings, page: newPage + 1 })}
                    onRowsPerPageChange={(event) => set_settings({ ...settings, page: 1, per_page: event.target.value })}
                />

                <TableContainer component={Paper}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell />
                                {/* <TableCell>Num</TableCell> */}
                                <TableCell>Ref</TableCell>
                                <TableCell>Temps</TableCell>
                                {/* <TableCell>Societe Interne</TableCell> */}
                                <TableCell>Utilisateur</TableCell>
                                {/* <TableCell>Societe Externe</TableCell> */}
                                {/* <TableCell>Utilisateur Externe</TableCell> */}
                                {/* <TableCell>Total TTC</TableCell> */}
                                <TableCell>Status</TableCell>
                                <TableCell align="center">Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {data?.length > 0 &&
                                data.map((row, i) => (
                                    <Row
                                        key={i}
                                        row={row}
                                        edit={edit}
                                        edit_loading={edit_loading}
                                        delete1={delete1}
                                        permissions={permissions}
                                        set_dialog_item={set_dialog_item}
                                        // set_dialog_edit_is_open={set_dialog_edit_is_open}
                                        set_dialog_edit_is_open={set_dialog_edit_is_open1}
                                        print_bar_code={print_bar_code}
                                        socket={socket}
                                    />
                                ))}
                        </TableBody>
                    </Table>
                </TableContainer>

                <TablePagination
                    rowsPerPageOptions={[5, 10, 15, 25, 50]}
                    component="div"
                    labelRowsPerPage="Ligne/Page"
                    count={rows_count}
                    rowsPerPage={settings?.per_page}
                    page={settings?.page - 1}
                    onPageChange={(event, newPage) => set_settings({ ...settings, page: newPage + 1 })}
                    onRowsPerPageChange={(event) => set_settings({ ...settings, page: 1, per_page: event.target.value })}
                />
            </Box>

            {/* <Dialog
                // key={dialog_item}
                open={dialog_edit_is_open}
                onClose={() => set_dialog_edit_is_open(false)}
                fullWidth
                maxWidth="xl"
                sx={{ minHeight: '600px !important', px: 10 }}
            // PaperComponent={PaperComponent}
            >
                <DialogTitle id="dialog1-title">{dialog_item?.id ? 'Edit' : 'Create'} Fabrication</DialogTitle>
                <DialogContent dividers sx={{ minHeight: 500 }}>
                    {dialog_item?.status_key && dialog_item?.status_key != 200 &&
                        <Grid>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={4}>
                                    <Autocomplete
                                        disablePortal
                                        disableListWrap
                                        value={dialog_item?.company1}
                                        options={companies ?? []}
                                        getOptionLabel={(o) => o?.name}
                                        renderInput={(params) => <TextField {...params} label="Company Externe" />}
                                        onChange={(e, v) => {
                                            set_dialog_item({ ...dialog_item, company1_id: v?.id, company1: v })
                                            load_products1({ company1_id: v?.id })
                                        }}
                                    />
                                </Grid>
                                {dialog_item?.status_key && dialog_item?.status_key == 300 && (
                                    <Grid item xs={12} sm={6}>
                                        <Autocomplete
                                            disablePortal
                                            disableListWrap
                                            value={dialog_item}
                                            options={payment_methods ?? []}
                                            getOptionLabel={(o) => o?.payment_method}
                                            renderInput={(params) => <TextField {...params} label="Payment Method" onBlur={(e) => { if (dialog_item?.payment_method?.length > 0 && payment_methods.filter(pm => pm?.payment_method == e.target.value).length == 0) { set_payment_methods((o) => [...o, { payment_method: e.target.value }]) } set_dialog_item({ ...dialog_item, payment_method: e.target.value }) }} />}
                                            onChange={(e, v) => set_dialog_item({ ...dialog_item, payment_method: v?.payment_method })}
                                        />
                                    </Grid>
                                )}
                            </Grid>

                            <Grid item xs={12} sx={{ marginTop: 3 }}>
                                <Typography variant="h6" gutterBottom>
                                    Details :
                                </Typography>
                            </Grid>
                        </Grid>
                    }

                    <Grid spacing={2} alignItems="center" justify="center" sx={{ mt: '16px' }}>

                        <Grid item xs={1}>
                            <Button variant="contained" color="primary"
                                onClick={() =>
                                    set_dialog_item(o1 => ({
                                        ...o1,
                                        operation_details: { ...o1.operation_details, [Object.values(dialog_item?.operation_details ?? []).length]: { product1_qte: 1 } }
                                    }))
                                }
                            >
                                Ajoute Produit
                            </Button>
                        </Grid>

                        {Object.values(dialog_item?.operation_details ?? []).map((od, odi) =>
                            <Grid container alignItems="center" key={odi} spacing={2} sx={{ mt: 2, border: 1, pb: 2, pr: 1 }}>

                                <Grid item xs={12} sm={2}>
                                    <Autocomplete
                                        disablePortal
                                        disableListWrap
                                        size="small"
                                        value={od?.category}
                                        options={categoryOptions ?? []}
                                        renderInput={(params) => <TextField {...params} label="Categorie" />}
                                        getOptionLabel={(o1) => o1?.name}
                                        onChange={(e, v) => {
                                            // console.log({ 'products.company_id': dialog_item?.company1_id, category_id: v?.id });
                                            setCategory(v)
                                            load_products1({ 'products.company_id': dialog_item?.company1_id, category_id: v?.id })
                                        }}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={3}>
                                    <Autocomplete
                                        disablePortal
                                        disableListWrap
                                        size="small"
                                        value={od?.product1}
                                        isOptionEqualToValue={(option, value) => option.id === value.id}
                                        options={products1 ? products1?.map((p) => ({ id: p.id, name: p?.name, ref: p?.ref, unit: p?.unit, type_consommation: p?.type_consommation })) : []}
                                        renderInput={(params) => <TextField {...params} label="Product" />}
                                        getOptionLabel={(o1) => o1?.name}
                                        onChange={(e, v) => {
                                            // fetchCategories({ company_id: v?.id, category_id: v?.id })
                                            // console.log(v?.type_consommation == 40);
                                            if (v?.type_consommation == 40) load_products2(v);

                                            set_dialog_item(o1 => ({
                                                ...o1,
                                                operation_details: Object.values(o1.operation_details ?? []).map((p, pi) => pi == odi ? { ...p, product1_id: v?.id, product1: v, product_id: v?.id } : p)
                                            }))
                                            // if (v?.ref?.length > 0)
                                            //     set_dialog_item(o1 => ({
                                            //         ...o1,
                                            //         operation_details: Object.values(o1.operation_details ?? []).map((p, pi) => pi == odi ? { ...p, product_id: products?.filter(p => p?.ref == v?.ref)?.[0]?.id, product: products?.filter(p => p?.ref == v?.ref)?.[0] } : p)
                                            //     }))
                                        }}
                                    />
                                </Grid>

                                {dialog_item?.status_key != 200 &&
                                    <Grid item xs={12} sm={4}>
                                        <Autocomplete
                                            disablePortal
                                            disableListWrap
                                            size="small"
                                            value={od?.product}
                                            options={products ? products?.map((p) => ({ id: p.id, name: p?.name })) : []}
                                            renderInput={(params) => <TextField {...params} label="Product Interne" />}
                                            getOptionLabel={(o2) => o2?.name}
                                            onChange={(e, v) =>
                                                set_dialog_item(o1 => ({
                                                    ...o1,
                                                    operation_details: Object.values(o1.operation_details ?? []).map((p, pi) => pi == odi ? { ...p, product_id: v?.id, product: v } : p)
                                                }))
                                            }
                                        />
                                    </Grid>
                                }

                                <Grid item xs={12} sm={3} justify="flex-end" justifyContent="space-between">
                                    <IconButton color="primary" onClick={() =>
                                        set_dialog_item(o1 => ({
                                            ...o1,
                                            operation_details: Object.values(o1.operation_details ?? []).map((p, pi) => pi == odi ? { ...p, product1_qte: parseInt(p?.product1_qte) + 1 } : p)
                                        }))
                                    }>
                                        <MdAdd />
                                    </IconButton>
                                    <TextField sx={{ maxWidth: '100px' }} type="number" inputProps={{ style: { textAlign: 'center' } }}
                                        value={od?.product1_qte}
                                        onChange={(e) =>
                                            set_dialog_item(o1 => ({
                                                ...o1,
                                                operation_details: Object.values(o1.operation_details ?? []).map((p, pi) => pi == odi ? { ...p, product1_qte: e.target.value } : p)
                                            }))
                                        }
                                    />
                                    <IconButton color="error" onClick={() =>
                                        set_dialog_item(o1 => ({
                                            ...o1,
                                            operation_details: Object.values(o1.operation_details ?? []).map((p, pi) => pi == odi ? { ...p, product1_qte: p?.product1_qte - 1 } : p)
                                        }))
                                    }>
                                        <MdRemove />
                                    </IconButton>
                                </Grid>

                                {od?.product1?.type_consommation == 40 &&
                                    <>
                                        <Typography sx={{ p: 2, fontSize: 20, fontWeight: 'bold' }}>Specification de Consommation :</Typography>

                                        {Object.values(od?.product_composant_parents_type_pa ?? []).map((p2, p2i) =>
                                            <Grid container alignItems="center" key={p2i} spacing={2} sx={{ pb: 2, pr: 1, ml: 2 }}>

                                                <Grid item xs={12} sm={3}>
                                                    <Typography sx={{ borderColor: 'grey.300', border: 1, p: 1 }}>
                                                        {p2?.name}
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={12} sm={3} justify="flex-end" justifyContent="space-between">
                                                    <IconButton color="primary" onClick={() =>
                                                        set_dialog_item(o1 => ({
                                                            ...o1,
                                                            operation_details: Object.values(o1.operation_details ?? []).map((p, pi) =>
                                                                pi == odi
                                                                    ? {
                                                                        ...p,
                                                                        product_composant_parents_type_pa: p?.product_composant_parents_type_pa.map((pcp, pcpi) =>
                                                                            pcpi == p2i ? { ...pcp, qte: pcp?.qte + 1 } : pcp
                                                                        ),
                                                                    }
                                                                    : p
                                                            )
                                                        }))
                                                    }>
                                                        <MdAdd />
                                                    </IconButton>
                                                    <TextField sx={{ maxWidth: '100px' }} type="number" inputProps={{ style: { textAlign: 'center' } }}
                                                        // set_products2(Object.values(res?.data?.data?.[0]?.product_composant_parents_type_pa)?.filter(p => p?.parent_product_type_pa)?.map(p => p?.parent_product_type_pa));
                                                        value={p2?.qte ?? 0}
                                                        onChange={(e) =>
                                                            set_dialog_item(o1 => ({
                                                                ...o1,
                                                                operation_details: Object.values(o1.operation_details ?? []).map((p, pi) =>
                                                                    pi == odi
                                                                        ? {
                                                                            ...p,
                                                                            product_composant_parents_type_pa: p?.product_composant_parents_type_pa.map((pcp, pcpi) =>
                                                                                pcpi == p2i ? { ...pcp, qte: e.target.value } : pcp
                                                                            ),
                                                                        }
                                                                        : p
                                                                )
                                                            }))
                                                        }
                                                    />
                                                    <IconButton color="error" onClick={() =>
                                                        set_dialog_item(o1 => ({
                                                            ...o1,
                                                            operation_details: Object.values(o1.operation_details ?? []).map((p, pi) =>
                                                                pi == odi
                                                                    ? {
                                                                        ...p,
                                                                        product_composant_parents_type_pa: p?.product_composant_parents_type_pa.map((pcp, pcpi) =>
                                                                            pcpi == p2i ? { ...pcp, qte: pcp?.qte - 1 } : pcp
                                                                        ),
                                                                    }
                                                                    : p
                                                            )
                                                        }))
                                                    }>
                                                        <MdRemove />
                                                    </IconButton>
                                                </Grid>
                                            </Grid>
                                        )}
                                    </>
                                }

                            </Grid>
                        )}
                    </Grid>
                </DialogContent>

                <DialogActions>
                    {!edit_loading && <Button onClick={() => set_dialog_edit_is_open(false)}>Cancel</Button>}
                    <LoadingButton
                        color="primary"
                        loading={edit_loading}
                        loadingPosition="start"
                        startIcon={<MdSave />}
                        variant="contained"
                        onClick={() =>
                            edit({
                                id: dialog_item?.id,
                                company1_id: dialog_item?.company1_id,
                                status_key: dialog_item?.status_key,
                                payment_method: dialog_item?.payment_method,
                                operation_details: Object.values(dialog_item?.operation_details ?? []).map(o => ({
                                    product_id: o?.product_id,
                                    product1_id: o?.product1_id,
                                    product1_qte: o?.product1_qte,
                                })),
                            })
                        }
                    >
                        Save{edit_loading && '...'}
                    </LoadingButton>
                </DialogActions>

            </Dialog> */}

            <Dialog
                open={dialog_edit_is_open1}
                onClose={() => { set_dialog_edit_is_open1(false), set_dialog_item({}) }}
                // fullWidth
                fullScreen
            // maxWidth="xl"
            >
                <DialogTitle id="dialog1-title">{dialog_item?.id ? 'Edit' : 'Create'} Operation</DialogTitle>
                <DialogContent dividers>

                    <Grid alignItems="center" justify="center">

                        {Object.values(dialog_item?.operation_details ?? []).map((od, odi) =>
                            <Grid container key={odi} alignItems="center" sx={{ mt: 2, border: 1, pb: 2, pr: 1, position: "relative" }}>

                                {!dialog_item?.id &&
                                    <Grid item xs={12} sm={1} justify="flex-end" justifyContent="space-between" sx={{ mb: 2 }}>
                                        <IconButton color="error"
                                            sx={{ position: "absolute", top: 5, right: 5 }}
                                            onClick={() =>
                                                set_dialog_item(o1 => ({
                                                    ...o1,
                                                    operation_details: Object.values(o1.operation_details ?? []).filter((p, pi) => pi != odi)
                                                }))
                                            }
                                        >
                                            <MdDeleteOutline size={100} />
                                        </IconButton>
                                    </Grid>
                                }
                                {!category && !od?.product1_id &&
                                    <Grid item xs={12} sm={12}>
                                        <ImageList cols={is_sm ? 2 : 4} gap={10}>
                                            {(categoryOptions ?? []).map((c, i) => (
                                                <ImageListItem key={c?.name} onClick={(e, v) => { setCategory(c) }}>
                                                    {c?.image ? (
                                                        <img
                                                            src={process.env.REACT_APP_URL + 'storage/' + c?.image}
                                                            alt={c?.name}
                                                            loading="lazy"
                                                        />
                                                    ) : (
                                                        <Stack direction="row" >
                                                            <Avatar variant="square" sx={{ width: '100%', height: { xs: 100, sm: 200 }, backgroundColor: getRandomColor(i), }}>
                                                                {c?.name.charAt(0).toUpperCase()}
                                                            </Avatar>
                                                        </Stack>
                                                    )}
                                                    <ImageListItemBar title={c?.name} />
                                                </ImageListItem>
                                            ))}
                                        </ImageList>
                                    </Grid>
                                }

                                {!od?.product1_id && category &&
                                    <Grid item xs={12} sm={12}>
                                        <ImageList cols={is_sm ? 1 : 4} gap={20}>
                                            {!(products1 ?? []).length &&
                                                <ImageListItem key="Subheader" cols={5}>
                                                    <ListSubheader component="div">Liste Produit Vide</ListSubheader>
                                                </ImageListItem>
                                            }
                                            {(products1 ?? []).filter(p => p?.category_id == category?.id).map((v, i) => (
                                                <ImageListItem key={i} onClick={() => {

                                                    set_dialog_item(o1 => ({
                                                        ...o1,
                                                        operation_details: Object.values(o1.operation_details ?? []).map((p, pi) => pi == odi ? { ...p, product1_id: v?.id, product1: v } : p)
                                                    }))
                                                    if (v?.ref?.length > 0) {
                                                        // console.log(v?.ref);
                                                        // console.log(products);
                                                        // console.log(products?.filter(p => p?.ref == v?.ref));
                                                        set_dialog_item(o1 => ({
                                                            ...o1,
                                                            operation_details: Object.values(o1.operation_details ?? []).map((p, pi) => pi == odi ? { ...p, product_id: products?.filter(p => p?.ref == v?.ref)?.[0]?.id, product: products?.filter(p => p?.ref == v?.ref)?.[0] } : p)
                                                        }))
                                                    }

                                                }}>
                                                    {v?.image ? (
                                                        <img
                                                            src={process.env.REACT_APP_URL + 'storage/' + v?.image}
                                                            alt={v?.name}
                                                            loading="lazy"
                                                        />
                                                    ) : (
                                                        <Stack direction="row" >
                                                            <Avatar variant="square" sx={{ width: '100%', height: { xs: 100, sm: 200 }, backgroundColor: getRandomColor(i), }}>
                                                                {v?.name.charAt(0).toUpperCase()}
                                                            </Avatar>

                                                        </Stack>
                                                    )}

                                                    <ImageListItemBar title={v?.name} />

                                                </ImageListItem>
                                            ))}
                                        </ImageList>


                                    </Grid>
                                }

                                {!od?.product_id && od?.product1 &&
                                    <Grid item xs={12} sm={3}>
                                        <Autocomplete
                                            disablePortal
                                            disableListWrap
                                            size="small"
                                            value={od?.product}
                                            isOptionEqualToValue={(option, value) => option.id === value.id}
                                            options={products ? products?.map((p) => ({ id: p.id, name: p?.name })) : []}
                                            renderInput={(params) => <TextField {...params} label="Product Interne" />}
                                            getOptionLabel={(o2) => o2?.name}
                                            onChange={(e, v) =>
                                                set_dialog_item(o1 => ({
                                                    ...o1,
                                                    operation_details: Object.values(o1.operation_details ?? []).map((p, pi) => pi == odi ? { ...p, product_id: v?.id, product: v } : p)
                                                }))
                                            }
                                        />
                                    </Grid>
                                }

                                {od?.product_id && od?.product1_id &&
                                    <Grid container sx={{ mt: 2, mx: 3 }}>
                                        <Grid item xs={12} sm={4}>
                                            <Typography variant="h4" component="h5" sx={{ my: 2 }}>
                                                {od?.product1?.name}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} md={7}>
                                            <Grid container >
                                                {dialog_item?.status_key == 10 &&
                                                    <Grid item xs={12} sm={4} justify="flex-end" justifyContent="space-between" sx={{ textAlign: 'center' }}>
                                                        <Typography>Qte Stockée</Typography>
                                                        <Box sx={{ mt: 1 }}>{od?.product?.qte}</Box>
                                                    </Grid>
                                                }
                                                <Grid item xs={12} sm={4} justify="flex-end" justifyContent="space-between" sx={{ textAlign: 'center' }}>
                                                    <Typography>Qte Préparer</Typography>
                                                    <IconButton color="primary" onClick={() =>
                                                        set_dialog_item(o1 => ({
                                                            ...o1,
                                                            operation_details: Object.values(o1.operation_details ?? []).map((p, pi) => pi == odi ? { ...p, product1_qte: parseInt(p?.product1_qte) + 1 } : p)
                                                        }))
                                                    }>
                                                        <MdAdd size={30} />
                                                    </IconButton>
                                                    <TextField sx={{ maxWidth: '150px' }} size="small" type="number"
                                                        inputProps={{ style: { textAlign: 'center' } }}
                                                        InputProps={{ startAdornment: od?.product1?.unit }}
                                                        value={od?.product1_qte}
                                                        onChange={(e) =>
                                                            set_dialog_item(o1 => ({
                                                                ...o1,
                                                                operation_details: Object.values(o1.operation_details ?? []).map((p, pi) => pi == odi ? { ...p, product1_qte: e.target.value } : p)
                                                            }))
                                                        }
                                                    />
                                                    <IconButton color="error" onClick={() =>
                                                        set_dialog_item(o1 => ({
                                                            ...o1,
                                                            operation_details: Object.values(o1.operation_details ?? []).map((p, pi) => pi == odi ? { ...p, product1_qte: p?.product1_qte - 1 } : p)
                                                        }))
                                                    }>
                                                        <MdRemove size={30} />
                                                    </IconButton>
                                                </Grid>
                                                {/* {!is_sm && */}
                                                <Grid >
                                                    <IconButton sx={{ mt: 3 }}
                                                        onClick={() => set_dialog_item(o1 => ({
                                                            ...o1,
                                                            operation_details: Object.values(o1.operation_details ?? []).map((p, pi) => pi == odi ? { ...p, dialpad: !p?.dialpad } : p)
                                                        }))
                                                        }
                                                    >
                                                        <Box sx={{ fontSize: 40, color: "primary.main" }}>
                                                            <MdDialpad />
                                                        </Box>
                                                    </IconButton>
                                                </Grid>
                                                {/* } */}
                                                {od?.dialpad &&
                                                    <Grid container xs={12} sm={4} sx={{ ml: 2 }}>
                                                        <Grid item container spacing={1} >
                                                            {[1, 2, 3, 4, 5, 6, 7, 8, 9, '<=', 0, 'C'].map((num, index) => (
                                                                <Grid item xs={4} key={index}>
                                                                    {num !== '' ? (
                                                                        <>
                                                                            {num == 'C' || num == '<=' ? (
                                                                                <>
                                                                                    {num == '<=' ? (
                                                                                        <Button
                                                                                            variant="outlined"
                                                                                            fullWidth
                                                                                            color="warning"
                                                                                            sx={{ py: 2, fontSize: '20px' }}
                                                                                            onClick={() => set_dialog_item(o1 => ({
                                                                                                ...o1,
                                                                                                operation_details: Object.values(o1.operation_details ?? []).map((p, pi) => pi == odi ? { ...p, product1_qte: p?.product1_qte?.toString()?.slice(0, -1) } : p)
                                                                                            }))
                                                                                            }
                                                                                        >
                                                                                            {num}
                                                                                        </Button>
                                                                                    ) : (
                                                                                        <Button
                                                                                            variant="outlined"
                                                                                            color="error"
                                                                                            fullWidth
                                                                                            sx={{ py: 2, fontSize: '20px' }}
                                                                                            onClick={() => set_dialog_item(o1 => ({
                                                                                                ...o1,
                                                                                                operation_details: Object.values(o1.operation_details ?? []).map((p, pi) => pi == odi ? { ...p, product1_qte: '' } : p)
                                                                                            }))
                                                                                            }
                                                                                        >
                                                                                            {num}
                                                                                        </Button>
                                                                                    )}
                                                                                </>
                                                                            ) : (
                                                                                <Button
                                                                                    variant="outlined"
                                                                                    fullWidth
                                                                                    sx={{ py: 2, fontSize: '20px' }}
                                                                                    onClick={() => set_dialog_item(o1 => ({
                                                                                        ...o1,
                                                                                        operation_details: Object.values(o1.operation_details ?? []).map((p, pi) => pi == odi ? { ...p, product1_qte: p?.product1_qte + num.toString() } : p)
                                                                                    }))
                                                                                    }
                                                                                >
                                                                                    {num}
                                                                                </Button>
                                                                            )}
                                                                        </>
                                                                    ) : (
                                                                        <div style={{ height: '48px' }} />
                                                                    )}
                                                                </Grid>
                                                            ))}
                                                        </Grid>
                                                    </Grid>
                                                }
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                }

                            </Grid>
                        )}

                        {!dialog_item?.id &&
                            <Grid item xs={1} sx={{ mt: 3 }}>
                                <Button variant="contained" color="primary"
                                    onClick={() => {
                                        // console.log(dialog_item);
                                        set_dialog_item(o1 => ({
                                            ...o1,
                                            operation_details: Object.fromEntries(
                                                Object.entries(o1.operation_details ?? {}).map(([key, value]) => [
                                                    key,
                                                    { ...value, dialpad: false }
                                                ])
                                            )
                                        }));

                                        set_dialog_item(o1 => ({
                                            ...o1,
                                            operation_details: { ...o1.operation_details, [Object.values(dialog_item?.operation_details ?? []).length]: { product1_qte: '', dialpad: true } }
                                        }))
                                        setCategory(null)
                                    }}
                                >
                                    Ajoute Produit
                                </Button>
                            </Grid>
                        }
                    </Grid>

                </DialogContent>

                <DialogActions sx={{ justifyContent: "space-between" }}>
                    <LoadingButton
                        color="primary"
                        loading={edit_loading}
                        loadingPosition="start"
                        startIcon={<MdSave />}
                        variant="contained"
                        onClick={() => {
                            // console.log(dialog_item)
                            edit({
                                id: dialog_item?.id,
                                company1_id: dialog_item?.company1_id,
                                status_key: dialog_item?.status_key,
                                payment_method: dialog_item?.payment_method,
                                operation_details: Object.values(dialog_item?.operation_details ?? []).map(o => ({
                                    product_id: o?.product_id,
                                    product1_id: o?.product1_id,
                                    product1_qte: o?.product1_qte,
                                })),
                            })
                            // setCategory(null)
                        }}
                    >
                        Save{edit_loading && '...'}
                    </LoadingButton>
                    {!edit_loading && <Button onClick={() => set_dialog_edit_is_open1(false)}>Cancel</Button>}
                    <Button
                        variant="outlined"
                        color="warning"
                        onClick={() => console.log("Left button click")}
                    >
                        Print
                    </Button>
                </DialogActions>

                {/* <DialogActions>
                                {!edit_loading && <Button onClick={() => set_dialog_edit_is_open1(false)}>Cancel</Button>}
                                <LoadingButton
                                    color="primary"
                                    loading={edit_loading}
                                    loadingPosition="start"
                                    startIcon={<MdSave />}
                                    variant="contained"
                                    onClick={() => {
                                        edit({
                                            id: dialog_item?.id,
                                            company1_id: dialog_item?.company1_id,
                                            status_key: dialog_item?.status_key,
                                            payment_method: dialog_item?.payment_method,
                                            operation_details: Object.values(dialog_item?.operation_details ?? []).map(o => ({
                                                product_id: o?.product_id,
                                                product1_id: o?.product1_id,
                                                product1_qte: o?.product1_qte,
                                            })),
                                        })
                                        setCategory(null)
                                    }}
                                >
                                    Save{edit_loading && '...'}
                                </LoadingButton>
                            </DialogActions> */}

            </Dialog>
        </MainCard >
    );
};

export default AppCRUD;
